import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../http/http.service';
import {
  USUARIOS_MINHA_CONTA,
  VENDAS_ORCAMENTO,
  VENDAS_ORCAMENTO_PUBLICO,
  VENDAS_PEDIDO,
  VENDAS_PEDIDO_CODIGO_CARTAO,
} from '../../core/config/endpoints';
import { CompraIngressoEntity } from '../../entitys/compra-ingresso.entity';
import { EventoEntity } from '../../entitys/evento.entity';
import Swall from 'sweetalert2';
import { closeLoader, dispararLoader } from '../../helpers/swall.helpers';
import { Router } from '@angular/router';
import { UserEntity } from '../../entitys/user.entity';
import { FormControl } from '@angular/forms';
import { EnderecoEntity } from '../../entitys/endereco.entity';
import { replaceEdpointParams } from '../../helpers/endpoints-helpers';
import { lerCookie } from '../../helpers/cookie.helpers';
import Swal from 'sweetalert2';
import { SessionService } from '../session-service/session.service';
import { CupomEntity } from 'src/app/entitys/cupom.entity';
import { finalize, firstValueFrom, Observable, Subject, tap } from 'rxjs';
import { PixelService } from 'src/app/lib/pixel/pixel.service';
import { getCheckoutContext } from 'src/app/api/generated/v3/checkout/checkout';
import type { DadosCarrinhoPayload } from 'src/app/api/generated/v3/schemas/dadosCarrinhoPayload';
import type { OrcamentoDto } from 'src/app/api/generated/v3/schemas/orcamentoDto';

export type orcamentoType = {
  valorPix: number;
  valorPaypal: number;
  valorTaxaServico: number;
  valorOriginal: number;
  valorDesconto: number;
  valorAcrescimoMap: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
    '6': number;
    '7': number;
    '8': number;
    '9': number;
    '10': number;
    '11': number;
    '12': number;
  };
  taxaParcelamentoMap: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
    '6': number;
    '7': number;
    '8': number;
    '9': number;
    '10': number;
    '11': number;
    '12': number;
  };
  valorParcelasMap: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
    '6': number;
    '7': number;
    '8': number;
    '9': number;
    '10': number;
    '11': number;
    '12': number;
  };
  valorTotalMap: {
    '1': number;
    '2': number;
    '3': number;
    '4': number;
    '5': number;
    '6': number;
    '7': number;
    '8': number;
    '9': number;
    '10': number;
    '11': number;
    '12': number;
  };
  valorAVista: number;
  valorSeguro?: number;
  // GUE-137: gate resolvido (global OR por-evento) — o checkout só mostra o opt-in quando true.
  seguroHabilitado?: boolean;
  pixQrCode?: string;
  // GUE-517: o backend devolve o paymentUrl da Carteira PicPay no mesmo `pixQrCode`. Este campo
  // diz de qual forma é o código pendente, para o accordion do Pix não exibir o link do PicPay
  // como chave Pix (e vice-versa). Ausente = Pix (sessões salvas antes da carteira existir).
  pagamentoPendente?: 'PIX' | 'CARTEIRA_PICPAY';
  // Prazo de aprovação da carteira, quando a resposta do pedido o informa.
  pagamentoExpiraEm?: string;
};

type dadosComprador = {
  nome: string;
  email: string;
  cpf: string;
  telefone: string;
  dataNascimento: string;
  nacionalidade: string;
  gringo: boolean;
};

type enderecoComprador = {
  cep: string;
  logradouro: string;
  numero: string | number;
  bairro: string;
  complemento: string;
  estado: string;
  cidade: string;
  pais: string;
};

type CarrinhoArgs = {
  evento: EventoEntity;
  ingressos: CompraIngressoEntity[];
  publico?: boolean;
  cupom?: CupomEntity;
};

type stepperPageType =
  'titular-ingresso' | 'pagamento' | 'codigo-cartao' | 'compra-finalizada';

type AddCupomArgs = {
  eventoId?: string;
  update?: boolean;
  callback?: (cupom: any) => void;
  listIngressos?: CompraIngressoEntity[];
};

export type CompraFinalizadaEventDetail = {
  orcamento: orcamentoType | null;
  evento?: EventoEntity;
  ingressos: CompraIngressoEntity[];
  produtos: any[];
  idPedido?: string;
};

@Injectable({
  providedIn: 'root',
})
export class CarrinhoIngressoService {
  private http = inject(HttpService);
  private router = inject(Router);
  private session = inject(SessionService);
  private pixel = inject(PixelService);
  private httpClient = inject(HttpClient);

  //Token da compra. enviado adicionalmente nas requisições
  tokenCompra?: string;
  idempotencyKey?: string;
  status?: string;
  // lista de ingressos
  ingressos: CompraIngressoEntity[] = [];
  // lista de produtos
  produtos: any[] = [];
  // evento
  evento?: EventoEntity;
  // ultima atualização do orçamento
  private _orcamento: orcamentoType | null = null;
  // dados do comprador
  dadosComprador?: dadosComprador;
  // dados do comprador
  cupom?: CupomEntity;
  idPedido: string | undefined;
  enderecoComprador?: enderecoComprador;
  formaDePagamento: 'CARTAO' | 'PIX' | 'PAYPAL' | 'WALLET' | 'CARTEIRA_PICPAY' =
    'CARTAO';
  dadosPagamento?: {
    nomeDoCartao: string;
    numeroDoCartao: string;
    mesDeVencimento: string;
    anoDeVencimento: string;
    cvv: string;
    parcelas: number;
  } | null;
  stepperPage: stepperPageType = 'titular-ingresso';

  set orcamento(orcamento: orcamentoType | null) {
    this._orcamento = orcamento;
    this.orcamentoSubject.next(orcamento);
  }

  get orcamento(): orcamentoType | null {
    return this._orcamento;
  }

  orcamento$: Observable<orcamentoType | null>;
  /** Chamadas de `updateOrcamento` em andamento (GUE-527: "Calculando parcelamento"). */
  private orcamentoPendentes = 0;
  get orcamentoCalculando(): boolean {
    return this.orcamentoPendentes > 0;
  }

  private orcamentoSubject = new Subject<orcamentoType | null>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {
    this.getData();
    this.orcamento$ = this.orcamentoSubject.asObservable();
  }

  /**
   * @description
   * Creates user_data object for Pixel events with demographic information
   * Includes: email, phone, name, gender, age (from dateOfBirth), city, state, neighborhood
   */
  getUserDataForPixel(): any {
    const dadosComprador = this.dadosComprador;
    const enderecoComprador = this.enderecoComprador;
    const userSession = this.session.user;

    // Use dados do comprador do carrinho se disponível, senão usa da sessão
    const email = dadosComprador?.email || userSession?.email;
    const telefone = dadosComprador?.telefone;
    const nomeCompleto = dadosComprador?.nome || userSession?.nome || '';
    const sobrenome = userSession?.sobrenome || '';

    // Separar nome e sobrenome
    const nomeParts = nomeCompleto.split(' ');
    const firstName = nomeParts[0] || '';
    const lastName =
      sobrenome || (nomeParts.length > 1 ? nomeParts.slice(1).join(' ') : '');

    // Dados demográficos
    const dataNascimento = dadosComprador?.dataNascimento;
    const cidade = enderecoComprador?.cidade;
    const estado = enderecoComprador?.estado;
    const bairro = enderecoComprador?.bairro;
    const cep = enderecoComprador?.cep;
    const nacionalidade = dadosComprador?.nacionalidade || 'BR';
    const userId = userSession?.id || dadosComprador?.cpf; // Use user ID or CPF as external ID

    // Criar user_data usando o PixelService
    // Note: bairro (neighborhood) não é campo padrão do Meta Pixel user_data
    // mas podemos incluir na cidade como "Cidade - Bairro" se necessário
    const cityWithNeighborhood =
      cidade && bairro ? `${cidade} - ${bairro}` : cidade;

    return this.pixel.createUserData({
      email: email,
      phone: telefone,
      firstName: firstName,
      lastName: lastName,
      dateOfBirth: dataNascimento,
      city: cityWithNeighborhood || cidade,
      state: estado,
      country: nacionalidade,
      zipCode: cep,
      externalId: userId,
      // Note: gender precisa ser obtido do UserEntity completo via API
      // Será incluído quando disponível nos dados do usuário
    });
  }

  getPixelIdsForEvento(evento?: EventoEntity): string[] {
    const pixelIds = this.pixel.getDefaultPixelIds();
    const metaPixelCode = evento?.metaPixelCode?.trim();

    if (metaPixelCode) {
      pixelIds.push(metaPixelCode);
    }

    return pixelIds;
  }

  private configurarPixelDoCarrinho(evento?: EventoEntity): void {
    // GUE-310: user_data no init = correspondência avançada (fbevents hasheia).
    // Só vale no primeiro init de cada pixel, então vai junto daqui.
    this.pixel.initialize(
      this.getPixelIdsForEvento(evento),
      this.getUserDataForPixel(),
    );
  }

  private criarDetalheCompraFinalizada(): CompraFinalizadaEventDetail {
    return {
      orcamento: this.orcamento,
      evento: this.evento,
      ingressos: [...(this.ingressos || [])],
      produtos: [...(this.produtos || [])],
      idPedido: this.idPedido,
    };
  }

  dispatchCompraFinalizada(): void {
    window.dispatchEvent(
      new CustomEvent<CompraFinalizadaEventDetail>('step-compra-finalizada', {
        detail: this.criarDetalheCompraFinalizada(),
      }),
    );
  }

  findDadosComprador(onDadosCarregados?: () => void) {
    if (this.dadosComprador && this.enderecoComprador) {
      onDadosCarregados?.();
      return;
    }
    this.http.get(USUARIOS_MINHA_CONTA).subscribe(
      (dadosComprador) => {
        if (!!dadosComprador) {
          if (!this.dadosComprador) {
            this.setDadosComprador(dadosComprador);
          }
          if (!this.enderecoComprador && dadosComprador?.endereco) {
            this.setEnderecoComprador(dadosComprador.endereco);
          }
        }
        closeLoader();
        onDadosCarregados?.();
      },
      () => {
        closeLoader();
      },
    );
  }

  /*##########################################################
   *################## Dados da session ######################
   * permiti manter os dados adicionados mesmo atualizando a tela
   */

  saveData() {
    const { cvv, ...dadosPagamento } = this.dadosPagamento || {};

    const data = {
      tokenCompra: this.tokenCompra,
      idempotencyKey: this.idempotencyKey,
      evento: this.evento,
      ingressos: this.ingressos,
      orcamento: this.orcamento,
      dadosComprador: this.dadosComprador,
      enderecoComprador: this.enderecoComprador,
      dadosPagamento: dadosPagamento,
      idPedido: this.idPedido,
      cupom: this.cupom,
      status: this.status,
      stepperPage: this.stepperPage,
    };
    window.sessionStorage.setItem('carrinho-ingresso', JSON.stringify(data));
  }

  getData() {
    const dataString = window.sessionStorage.getItem('carrinho-ingresso');
    if (!dataString) return;

    const data = JSON.parse(dataString);

    this.tokenCompra = data?.tokenCompra;
    this.idempotencyKey = data?.idempotencyKey;
    this.evento = data?.evento;
    this.ingressos = data?.ingressos;
    this.orcamento = data?.orcamento;
    this.dadosComprador = data?.dadosComprador;
    this.enderecoComprador = data?.enderecoComprador;
    this.dadosPagamento = data?.dadosPagamento;
    this.idPedido = data?.idPedido;
    this.status = data?.status;
    this.stepperPage = data?.stepperPage || 'titular-ingresso';
    if (data?.cupom) {
      this.cupom = data.cupom;
      if (!!this.cupom?.nome) {
        this.inputCupom.patchValue(this.cupom.nome);
      }
      this.inputCupom.disable();
    }
  }

  setStep(stepper: stepperPageType) {
    this.stepperPage = stepper;
    this.saveData();
  }

  /*##########################################################
   *################ Compra e pagamento ######################
   */

  // Inicía o carrinho com o evento adicionado.
  // Resolve só depois do checkout-context + saveData — necessário para o fluxo
  // sem sessão (GUE-562) gravar o carrinho antes de ir ao login.
  async startCarrinho(args: CarrinhoArgs): Promise<void> {
    const { evento, ingressos, cupom } = args || {};

    this.evento = evento;
    this.ingressos = ingressos;
    this.produtos = [];
    this.configurarPixelDoCarrinho(evento);
    this.dadosComprador = undefined;
    this.enderecoComprador = undefined;
    this.dadosPagamento = undefined;
    this.cupom = cupom;
    this.stepperPage = 'titular-ingresso';
    // Garantir que não haja QRCode PIX residual de fluxos anteriores
    this.limparCobrancaPendente();

    const hasSession = !!this.session.user?.email;

    await this.checkoutAsync(async () => {
      this.saveData();
      // Get user data for demographic tracking
      const userData = this.getUserDataForPixel();

      this.pixel.track('InitiateCheckout', {
        value: this.orcamento?.valorPix,
        currency: 'BRL',
        content_name: this.evento?.nome,
        content_ids: this.ingressos.map((i) => i.lote.id as string),
        content_type: 'product',
        num_items: this.ingressos.length,
        ...(userData && { user_data: userData }),
      });
      if (!hasSession) return;

      await this.router.navigate(['private/eventos/ingressos']);
      setTimeout(() => closeLoader(), 500);
    });
  }

  // Inicia o carrinho com produtos; se o total não for > 0, pula pagamento e finaliza
  async startCarrinhoProdutos(
    evento: EventoEntity,
    produtos: any[],
    cupom?: CupomEntity,
    totalCompra?: number,
  ) {
    this.evento = evento;
    this.ingressos = [];
    this.produtos = produtos.filter((p) => p.quantidade > 0);
    this.configurarPixelDoCarrinho(evento);
    this.dadosPagamento = undefined;
    this.cupom = cupom;
    // Garantir que não haja QRCode PIX residual de fluxos anteriores
    this.limparCobrancaPendente();
    // Decisão da etapa é feita com base no total de produtos selecionados

    // Não limpar dados do comprador e endereço, pois são necessários para produtos também
    // Se não existirem, serão carregados automaticamente no componente

    const hasSession = !!this.session.user?.email;

    this.checkout(async () => {
      this.saveData();

      const prepareCompradorSeNecessario = async () => {
        if (!hasSession) return;
        if (!this.dadosComprador || !this.enderecoComprador) {
          await new Promise<void>((resolve) => {
            this.http.get(USUARIOS_MINHA_CONTA).subscribe(
              (dadosComprador) => {
                if (!!dadosComprador) {
                  if (!this.dadosComprador) {
                    this.setDadosComprador(dadosComprador);
                  }
                  if (!this.enderecoComprador && dadosComprador?.endereco) {
                    this.setEnderecoComprador(dadosComprador.endereco);
                  }
                }
                this.saveData();
                resolve();
              },
              () => {
                resolve();
              },
            );
          });
        }
      };

      // Decide fluxo usando o total informado pela tela (sem recalcular)
      const totalProdutos = Number(totalCompra) || 0;

      if (totalProdutos <= 0) {
        await this.router.navigate(['private/eventos/ingressos']);
        this.setDadosPagamentoFree();
        return;
      }

      // Fluxo com pagamento
      this.stepperPage = 'pagamento';
      await prepareCompradorSeNecessario();
      await this.router.navigate(['private/eventos/ingressos']);
      setTimeout(() => closeLoader(), 500);

      // Get user data for demographic tracking
      const userData = this.getUserDataForPixel();

      this.pixel.track('InitiateCheckout', {
        value: totalProdutos,
        currency: 'BRL',
        content_name: this.evento?.nome,
        content_ids: this.produtos.map((p) => p.id as string),
        content_type: 'product',
        num_items: this.produtos.reduce(
          (sum, p) => sum + (p.quantidade || 0),
          0,
        ),
        ...(userData && { user_data: userData }),
      });
    });
  }

  getRequestData(): { [key: string]: any } {
    const dadosComprador = this.dadosComprador;
    const enderecoComprador = this.enderecoComprador;

    // Preparar produtosIds e produtos
    const produtosIds: string[] = [];
    this.produtos.forEach((produto) => {
      if (produto.quantidade && produto.id) {
        for (let i = 0; i < produto.quantidade; i++) {
          produtosIds.push(String(produto.id));
        }
      }
    });

    // Preparar dados base
    const payload: any = {
      cupomId: (this.cupom?.id as string) || null,
      formaDePagamento: this.formaDePagamento,
      lotesIds: this.ingressos.map((ingresso) => String(ingresso.lote.id)),
      metodoPagamento: null,
      produtosIds: produtosIds,
      ingressos: [],
      dadosComprador: {
        nacionalidade: dadosComprador?.nacionalidade || 'BR',
        nome: dadosComprador?.nome || null,
        email: dadosComprador?.email || null,
        cpf: dadosComprador?.cpf || null,
        telefone: dadosComprador?.telefone || null,
        dataNascimento: dadosComprador?.dataNascimento
          ? this.formatarDataParaPayload(dadosComprador?.dataNascimento)
          : null,
        gringo: dadosComprador?.gringo || null,
      },
      dadosEndereco: {
        pais: enderecoComprador?.pais || 'BR',
        cep: enderecoComprador?.cep || null,
        logradouro: enderecoComprador?.logradouro || null,
        numero: enderecoComprador?.numero || null,
        bairro: enderecoComprador?.bairro || null,
        complemento: enderecoComprador?.complemento || null,
        estado: enderecoComprador?.estado || null,
        cidade: enderecoComprador?.cidade || null,
      },
      dadosPagamento: this.dadosPagamento,
      parcelas: this.dadosPagamento?.parcelas || null,
      // GUE-315: o Purchase passa a sair do backend, no webhook de pagamento — que não tem
      // navegador do outro lado. Estes dois cookies só existem aqui, e o _fbc é o carimbo do
      // clique no anúncio: sem ele o evento chega anônimo. Ausentes = comprador não veio de
      // anúncio, ou bloqueador impediu o pixel; o backend trata como opcional.
      fbp: lerCookie('_fbp'),
      fbc: lerCookie('_fbc'),
    };

    // Adicionar produtos apenas se houver produtos, utilizando loteId e nomeProduto
    if (this.produtos.length > 0) {
      payload.produtos = this.produtos
        .filter((p) => p.quantidade > 0)
        .map((p) => ({
          loteId: p?.loteId ?? p?.lote?.id ?? p.id,
          nomeProduto: p?.nome ?? p?.produto?.nome,
        }));
    }

    // Adicionar ingressos (se houver)
    if (this.ingressos.length > 0) {
      payload.ingressos = this.ingressos.map((item) => ({
        nome: item.ingresso.nome,
        email: item.ingresso.email,
        loteId: item.lote.id,
        nomeLote: item.lote.nome,
        sessaoId: null,
        assentoId: null,
        // Seguro-ingresso IZA (GUE-137): só sai preenchido quando o opt-in está válido.
        // dataNascimento já vem em yyyy-MM-dd do input nativo (não reformatar).
        queroSeguro: !!item.ingresso.queroSeguro,
        cpf: item.ingresso.queroSeguro ? (item.ingresso.cpf ?? null) : null,
        dataNascimento: item.ingresso.queroSeguro
          ? (item.ingresso.dataNascimento ?? null)
          : null,
        aceiteSeguroVersao: item.ingresso.queroSeguro
          ? (item.ingresso.aceiteSeguroVersao ?? null)
          : null,
        aceiteSeguroIp: item.ingresso.queroSeguro
          ? (item.ingresso.aceiteSeguroIp ?? null)
          : null,
      }));
    }

    return payload;
  }

  private finalizarCompra2(data: { [key: string]: any }) {
    if (!this.tokenCompra) {
      alert('token não encontrado');
      return;
    }

    return this.http.post(VENDAS_PEDIDO, data, {
      params: {
        retornarPedidoPaypal: 'true',
        retornarPedidoWallet: 'true',
      },
      headers: {
        'x-dg-ticket-token': this.tokenCompra,
        'x-dg-ticket-iswebapp': 'true',
        ...(this.idempotencyKey
          ? { 'Idempotency-Key': this.idempotencyKey }
          : {}),
        // 'minimumAppBuildNumber': '380',
        // ['x-dg-app-version']: '5.1.0+391',
      },
    });
  }

  limparCarrinho() {
    this.tokenCompra = undefined;
    this.idempotencyKey = undefined;
    this.ingressos = [];
    this.produtos = [];
    this.evento = undefined;
    this.orcamento = null;
    this.dadosComprador = undefined;
    this.enderecoComprador = undefined;
    this.formaDePagamento = 'CARTAO';
    this.dadosPagamento = null;
    // Sem isto, a compra seguinte na mesma aba reusa o idPedido da anterior como
    // eventID do Purchase e o Meta deduplica as duas, perdendo a conversão.
    // Precisa vir antes de removeCupom(), que persiste o estado via saveData().
    this.idPedido = undefined;
    this.pixel.initialize();
    this.removeCupom();
  }

  /**
   * @description
   * Track cart abandonment event when user leaves checkout without completing purchase
   */
  trackCartAbandonment(): void {
    // Don't track abandonment if purchase was completed
    if (this.stepperPage === 'compra-finalizada') {
      return;
    }

    // Only track if checkout was initiated (has InitiateCheckout) and cart has items
    if (!this.evento || (!this.ingressos.length && !this.produtos.length)) {
      return;
    }

    // Only track if there's a token (checkout was initiated)
    if (!this.tokenCompra) {
      return;
    }

    const totalValue =
      this.orcamento?.valorPix || this.orcamento?.valorAVista || 0;
    const contentIds = [
      ...(this.ingressos.map((i) => String(i.lote.id)) || []),
      ...(this.produtos.map((p) => String(p.id)) || []),
    ];
    const numItems =
      this.ingressos.length +
      this.produtos.reduce((sum, p) => sum + (p.quantidade || 0), 0);

    // Get user data for demographic tracking
    const userData = this.getUserDataForPixel();

    // Track custom event for cart abandonment
    this.pixel.trackCustom('AbandonCart', {
      value: totalValue,
      currency: 'BRL',
      content_name: this.evento?.nome || 'Carrinho',
      content_ids: contentIds,
      content_type: 'product',
      num_items: numItems,
      ...(userData && { user_data: userData }),
    });
  }

  private dadosCarrinho(): DadosCarrinhoPayload {
    const produtosIds = this.produtos.flatMap((produto) =>
      produto.quantidade && produto.id
        ? Array(produto.quantidade).fill(String(produto.id))
        : [],
    );

    return {
      cupomId: this.cupom?.id ?? null,
      formaDePagamento: 'CARTAO',
      lotesIds: this.ingressos.map((ingresso) => String(ingresso.lote.id)),
      produtosIds,
      lotesComSeguro: this.ingressos
        .filter((ingresso) => ingresso.ingresso.queroSeguro)
        .map((ingresso) => String(ingresso.lote.id)),
    };
  }

  private valoresEmReais(
    valores?: Record<string, number>,
  ): Record<string, number> {
    return Object.fromEntries(
      Object.entries(valores ?? {}).map(([parcelas, valor]) => [
        parcelas,
        valor / 100,
      ]),
    );
  }

  private adotarOrcamento(cotacao: OrcamentoDto): orcamentoType {
    return {
      valorPix: (cotacao.valorPix ?? 0) / 100,
      valorPaypal: (cotacao.valorPaypal ?? 0) / 100,
      valorTaxaServico: (cotacao.valorTaxaServico ?? 0) / 100,
      valorOriginal: (cotacao.valorOriginal ?? 0) / 100,
      valorDesconto: (cotacao.valorDesconto ?? 0) / 100,
      valorAVista: (cotacao.valorAVista ?? cotacao.valorPix ?? 0) / 100,
      valorAcrescimoMap: this.valoresEmReais(cotacao.valorAcrescimoMap),
      taxaParcelamentoMap: cotacao.taxaParcelamentoMap ?? {},
      valorParcelasMap: this.valoresEmReais(cotacao.valorParcelasMap),
      valorTotalMap: this.valoresEmReais(cotacao.valorTotalMap),
      valorSeguro:
        cotacao.valorSeguro === undefined
          ? undefined
          : cotacao.valorSeguro / 100,
      seguroHabilitado: cotacao.seguroHabilitado,
    } as orcamentoType;
  }

  checkout(callback: () => void) {
    void this.checkoutAsync(callback);
  }

  /** Mesmo que `checkout`, mas aguardável (GUE-562: persistir carrinho antes do login). */
  private async checkoutAsync(
    callback: () => void | Promise<void>,
  ): Promise<void> {
    if (!this.evento?.id) return;

    const contexto = await getCheckoutContext(
      this.httpClient,
      String(this.evento.id),
      this.dadosCarrinho(),
    );
    this.tokenCompra = contexto.checkoutSession.sessionToken;
    this.idempotencyKey = contexto.idempotencyKey;
    this.orcamento = this.adotarOrcamento(contexto.cotacao);
    await callback();
  }

  updateOrcamento(
    publico: boolean = false,
    onUpdated?: (orcamento: orcamentoType | null) => void,
  ) {
    const data = this.dadosCarrinho();

    // Se não houver ingressos ou produtos o backend retorna um erro.
    if (data.lotesIds.length === 0 && (data.produtosIds?.length ?? 0) === 0) {
      this.orcamento = null;
      this.saveData();
      return;
    }

    const endpoint = publico ? VENDAS_ORCAMENTO_PUBLICO : VENDAS_ORCAMENTO;
    const headers: Record<string, string> = {};
    if (this.tokenCompra) {
      headers['x-dg-ticket-token'] = this.tokenCompra;
    }
    this.orcamentoPendentes++;
    this.http
      .post(endpoint, data, {
        headers,
      })
      .pipe(
        finalize(() => {
          this.orcamentoPendentes = Math.max(0, this.orcamentoPendentes - 1);
        }),
      )
      .subscribe((resp) => {
        this.orcamento = resp;
        this.saveData();
        try {
          onUpdated && onUpdated(this.orcamento);
        } catch {}
      });
  }

  /*##########################################################
   * ###################### Cupom ############################
   */

  inputCupom = new FormControl('');

  async swalFindCupom(
    eventoId = this.evento?.id,
    callback?: (cupom: any) => void,
  ) {
    const cupom = await Swall.fire({
      title: 'Adicionar cupom',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Aplicar',
      cancelButtonText: 'sair',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swall.isLoading(),
    }).then((result) => {
      if (result.value && result.isConfirmed) {
        return result.value;
      }
      return false;
    });

    if (cupom) {
      dispararLoader();
      this.findCupom(cupom, eventoId).subscribe(
        (resp) => {
          if (!resp?.disponivel) {
            Swall.fire({
              icon: 'error',
              text: resp?.reasonMessage || 'Cupom inválido',
              timer: 1500,
            }).then();
            return;
          }

          closeLoader();
          if (callback) {
            callback(resp?.cupom);
          } else {
            this.cupom = resp?.cupom;
            this.updateOrcamento();
            this.saveData();
          }
        },
        (error: any) => {
          Swall.fire({
            icon: 'error',
            text: error?.error?.reasonMessage || 'Erro ao buscar cupom',
            timer: 1000,
          });
        },
      );
    }
  }

  completeFindCupom({
    eventoId = this.evento?.id as string,
    update = true,
    callback,
    listIngressos,
  }: AddCupomArgs = {}) {
    if (!this.inputCupom.value) return;

    const cupom = this.inputCupom.value;

    setTimeout(() => {
      dispararLoader();
      this.findCupom(cupom, eventoId).subscribe(
        (resp) => {
          if (!resp?.disponivel) {
            Swall.fire({
              icon: 'error',
              text: resp?.reasonMessage || 'Cupom inválido',
              timer: 1500,
            }).then();
            return;
          }

          const lotesValidos: any[] = resp?.cupom?.lotes || [];
          const ingressos = listIngressos || this.ingressos;
          const valido =
            resp?.cupom?.aplicavelEmTodosOsLotes ||
            ingressos.some((ingresso) =>
              lotesValidos.some((lote) => lote.id === ingresso.lote.id),
            );

          if (!valido && ingressos.length > 0) {
            Swal.fire({
              icon: 'error',
              title: 'Esse cupom não é aplicavel aos lotes selecionáveis',
            }).then();
            this.removeCupom();
            return;
          }

          closeLoader();

          this.cupom = resp?.cupom;

          if (!!callback) callback(this.cupom);
          if (update) {
            this.updateOrcamento();
            this.saveData();
          }
          if (!!this.cupom?.nome) {
            this.inputCupom.patchValue(this.cupom.nome);
          }
          this.inputCupom.disable();
        },
        (error: any) => {
          Swall.fire({
            icon: 'error',
            text: error?.error?.reasonMessage || 'Erro ao buscar cupom',
            timer: 1000,
          });
        },
      );
    }, 10);
  }

  findCupom(cupom: string, eventoId = this.evento?.id) {
    return this.http.get('api/v2/cupom/disponivel/' + eventoId + '/' + cupom);
  }

  removeCupom() {
    this.cupom = undefined;
    this.inputCupom.patchValue('');
    this.inputCupom.enable();
    this.updateOrcamento();
    this.saveData();
  }

  /*##########################################################
   * #################### Pagamento ##########################
   */

  finalizarComCartao() {
    if (!this.tokenCompra) {
      alert('token não encontrado');
      return;
    }

    this.formaDePagamento = 'CARTAO';
    const data = this.getRequestData();
    dispararLoader();

    this.finalizarCompra2(data)?.subscribe(
      (resp) => {
        closeLoader();
        this.status = resp.status;
        if (this.formaDePagamento == 'CARTAO') {
          // this.idPedido = resp?.idPedido;
          this.setIdPedido(resp?.idPedido);
          window.dispatchEvent(new CustomEvent('step-codigo-cartao'));
        } else {
          this.dispatchCompraFinalizada();
        }
      },
      (error) => {
        console.log(error?.error);
        Swall.fire({
          icon: 'error',
          title: error?.error?.message || 'Erro na compra',
        }).then();
      },
    );
  }

  finalizarComWallet() {
    if (!this.tokenCompra) {
      alert('token não encontrado');
      return;
    }

    this.formaDePagamento = 'WALLET';
    const data = this.getRequestData();
    dispararLoader();

    return this.finalizarCompra2(data)?.pipe(
      tap((resp) => {
        closeLoader();
        this.status = resp.status;
        this.setIdPedido(resp?.idPedido);
      }),
    );
  }

  codigoCartao(codigo: string) {
    if (!this.idPedido) return;
    this.http
      .post(
        replaceEdpointParams(VENDAS_PEDIDO_CODIGO_CARTAO, this.idPedido),
        codigo,
      )
      .subscribe(
        () => {
          this.dispatchCompraFinalizada();
        },
        (error) => {
          console.log(error?.error);
          Swall.fire({
            icon: 'error',
            title: error?.error?.message || 'Erro na confirmação do código',
          }).then();
        },
      );
  }

  setDadosPagamentoCartao(data: any) {
    this.dadosPagamento = {
      cvv: data.cvv,
      numeroDoCartao: data.numeroDoCartao.trim(),
      mesDeVencimento: (String(data.vencimento) || '')?.substring(0, 2),
      anoDeVencimento: (String(data.vencimento) || '')?.substring(2),
      nomeDoCartao: data.nomeDoCartao,
      parcelas: Number(data.parcelas),
    };

    // Get user data for demographic tracking
    const userData = this.getUserDataForPixel();

    // Track AddPaymentInfo event
    this.pixel.track('AddPaymentInfo', {
      value: this.orcamento?.valorPix || this.orcamento?.valorAVista || 0,
      currency: 'BRL',
      content_name: this.evento?.nome || 'Compra',
      content_ids: [
        ...(this.ingressos.map((i) => String(i.lote.id)) || []),
        ...(this.produtos.map((p) => String(p.id)) || []),
      ],
      content_type: 'product',
      ...(userData && { user_data: userData }),
    });

    this.saveData();
  }

  setDadosPagamentoPix() {
    this.dadosPagamento = null;
    this.formaDePagamento = 'PIX';
    const data = this.getRequestData();
    dispararLoader();

    this.finalizarCompra2(data)?.subscribe(
      (resp) => {
        closeLoader();
        // GUE-520: antes do orçamento, que é quem liga o polling do status na tela.
        this.setIdPedido(resp?.idPedido);
        // Atualiza o orcamento de forma reativa para refletir na UI
        const current = this.orcamento || ({} as any);
        this.orcamento = { ...current, pixQrCode: resp.pixQrCode } as any;
        this.saveData();
      },
      (error) => {
        Swall.fire({
          icon: 'error',
          title: error?.error?.message || 'Erro ao solicitar chave pix',
        }).then();
      },
    );
  }

  /** Carteira PicPay (GUE-517): mesmo ciclo assíncrono do Pix — o pedido fica PENDENTE e a
   * resposta traz o paymentUrl em `pixQrCode`, exibido como QR e como link "Abrir no PicPay". */
  setDadosPagamentoCarteira() {
    this.dadosPagamento = null;
    this.formaDePagamento = 'CARTEIRA_PICPAY';
    const data = this.getRequestData();
    dispararLoader();

    this.finalizarCompra2(data)?.subscribe(
      (resp) => {
        closeLoader();
        // GUE-520: antes do orçamento, que é quem liga o polling do status na tela.
        this.setIdPedido(resp?.idPedido);
        const current = this.orcamento || ({} as any);
        this.orcamento = {
          ...current,
          pixQrCode: resp.pixQrCode,
          pagamentoPendente: 'CARTEIRA_PICPAY',
          pagamentoExpiraEm: resp.expiresAt ?? resp.dataExpiracao ?? undefined,
        } as any;
        this.saveData();
      },
      (error) => {
        Swall.fire({
          icon: 'error',
          title:
            error?.error?.message || 'Erro ao iniciar pagamento com PicPay',
        }).then();
      },
    );
  }

  setDadosPagamentoFree() {
    this.dadosPagamento = null;
    const data = this.getRequestData();
    dispararLoader();
    const action = () => {
      this.limparCarrinho();

      this.stepperPage = 'titular-ingresso';
      if (this.evento) {
        void this.router.navigate(
          ['/evento', this.evento.codigo ?? this.evento.id],
          {
            queryParams: {
              ...(this.cupom ? { cupom: this.cupom.nome } : {}),
            },
            queryParamsHandling: 'merge',
          },
        );
      } else {
        void this.router.navigate(['/']);
      }
    };

    this.finalizarCompra2(data)?.subscribe(
      (resp) => {
        // No fluxo gratuito o backend devolve CompraCheckoutDto — formaDePagamento
        // continua 'CARTAO' aqui — então o idPedido VEM nesta resposta.
        // Tem que ser gravado ANTES do dispatch: criarDetalheCompraFinalizada()
        // lê this.idPedido para montar o eventID do Purchase.
        this.setIdPedido(resp?.idPedido);
        this.dispatchCompraFinalizada();
        closeLoader();
      },
      (error) => {
        if (Swal.isLoading()) {
          closeLoader();
        }
        console.log(error?.error);
        Swall.fire({
          icon: 'error',
          title: error?.error?.message || 'Erro na compra',
          didClose: error?.error?.code === 'TKN1002' ? action : undefined,
        }).then();
      },
    );
  }

  // Aceita undefined de propósito: os call sites passam `resp?.idPedido`, e nem
  // toda resposta do backend carrega o campo (PayPal devolve PaypalOrderResponseDto,
  // wallet devolve o PaymentIntent cru do Stripe). Tipar como `string` era mentira
  // e escondia esses casos do compilador.
  setIdPedido(idPedido: string | undefined) {
    this.idPedido = idPedido;
    this.saveData();
  }

  /**
   * Tira do orçamento a cobrança assíncrona pendente (Pix/Carteira PicPay) e o idPedido dela,
   * liberando outra forma de pagamento. Sem cobrança pendente, não faz nada.
   */
  limparCobrancaPendente() {
    if (!this.orcamento?.pixQrCode) return;
    this.idPedido = undefined;
    this.orcamento = {
      ...this.orcamento,
      pixQrCode: undefined,
      pagamentoPendente: undefined,
      pagamentoExpiraEm: undefined,
    };
    this.saveData();
  }

  /*##########################################################
   * ################## INGRESSOS ############################
   */

  vefiryDataIngressos() {
    const dataError = this.ingressos.find((ingressoCompra) => {
      return !ingressoCompra.ingresso.nome || !ingressoCompra.ingresso.email;
    });

    return !dataError;
  }

  preencherTitularesComDadosDoCompradorSeHabilitado(
    habilitado: boolean,
  ): boolean {
    const nome = this.dadosComprador?.nome?.trim();
    const email = this.dadosComprador?.email?.trim();
    if (
      !habilitado ||
      !nome ||
      !email ||
      !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)
    ) {
      return false;
    }

    this.ingressos.forEach((item) => {
      item.ingresso.nome = nome;
      item.ingresso.email = email;
    });
    this.saveData();
    return this.ingressos.length > 0;
  }

  /*##########################################################
   * ############### Dados do comprador ######################
   */

  setEnderecoComprador(dados?: Partial<EnderecoEntity> | null) {
    const endereco = {
      cep: dados?.cep || '',
      logradouro: dados?.logradouro || '',
      numero: dados?.numero?.toString() || '',
      bairro: dados?.bairro || '',
      complemento: dados?.complemento || '',
      estado: dados?.estado || '',
      cidade: dados?.cidade || '',
      pais: dados?.pais || this.enderecoComprador?.pais || 'BR',
    };

    // País sozinho não conta como endereço preenchido (evita pular o fetch da conta).
    const { pais: _pais, ...camposEndereco } = endereco;
    const hasEndereco = Object.values(camposEndereco).some(
      (value) => value.trim().length > 0,
    );
    this.enderecoComprador = hasEndereco ? endereco : undefined;
    this.saveData();
  }

  setDadosComprador(dados: UserEntity) {
    const nacionalidade = dados?.nacionalidade || 'BR';
    this.dadosComprador = {
      nome: dados?.nome || '',
      email: dados?.email || '',
      cpf: dados?.cpf || '',
      nacionalidade,
      telefone: dados?.telefone || '',
      dataNascimento: dados?.dataNascimento || '',
      gringo: dados?.gringo != null ? !!dados.gringo : nacionalidade !== 'BR',
    };
    this.saveData();
  }

  setDadosPagamentoPaypal() {
    this.dadosPagamento = null;
    this.formaDePagamento = 'PAYPAL';
    const data = this.getRequestData();
    dispararLoader();

    // O idPedido tem que ser gravado AQUI, e não no onApprove: o onApprove chama
    // dispatchCompraFinalizada(), que monta o detalhe lendo this.idPedido. Se
    // esperar até lá, o Purchase sai com eventID errado.
    // O backend passou a devolver idPedido no PaypalOrderResponseDto (GUE-305);
    // antes disso a resposta só trazia o order id do próprio PayPal.
    return firstValueFrom(this.finalizarCompra2(data)!)
      .then((resp) => {
        this.setIdPedido(resp?.idPedido);
        return resp;
      })
      .finally(closeLoader);
    //  ?.subscribe(
    //   resp => {
    //     closeLoader()
    //     console.log(resp)
    //     this.saveData();
    //   },
    //   error => {
    //     Swall.fire({
    //       icon: 'error',
    //       title: error?.error?.message || 'Erro ao solicitar chave pix'
    //     }).then()
    //   }
    // )
  }

  formatarDataParaPayload(data: string | Date): string {
    const d = new Date(data);

    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0'); // mês começa em 0
    const dia = String(d.getDate()).padStart(2, '0');

    return `${ano}-${mes}-${dia}T00:00:00.000`;
  }
}
